// * MODIFIER 2 OBJECT * //
// * Sector 2 Modifiers reflect the MOBILITY of a unit or SIZE/RANGE/ALTITUDE of unit equipment ex- Air Assault, Wheeled, Mountain, etc * //
// ! If any Mod2 object is a mobility indicator, then you MUST add in the key-value "mobility: true". Refer to "Amphibious" as a template
// ! MOBILITY INDICATORS: These are only used for equipment and depicts the mobility feature that is NOT intrinsic to the piece of equipment itself. For example; a self propelled howitzer moving by train would get the "Rail" mobility indicator because the railway is not a part of a self propelled howitzer. These mobility indicators are put at the bottom of equipment symbols. An object like a heavy truck would have the wheeled indicator but since it is intrinsic to a truck it will not be placed below the symbol.
// ! The following are the only mobility indicators: Wheeled (limited cross country), Wheeled (cross country), Tracked, Wheeled and Tracked Combination, Towed, Railway, Over-snow, Sled, Pack Animals, Barge and Amphibious.
// ! Refer to 5-17 in ADRP 1-02 (AUG 2018)
//! Refer to "Amphibious" if you need to learn how to reconstruct a mobility indicator
const mod2Object = {
  None: {
    type: 'Default',
    affiliation: {
      friendly: {
        path_1: {
          d: '',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
    },
  },
  Bicycle: {
    type: 'Infantry',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M89,132a11,11 0 1,0 22,0a11,11 0 1,0 -22,0',
          transform: 'translate(0,3)',
          strokeWidth: 3,
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,10)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,7)';
        return propertyToModify;
      },
    },
  },
  'Motorized (Outdated)': {
    type: 'Mobility',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M100,50L100,150',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.d = 'M100,30L100,170';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.d = 'M100,43L100,156';
        return propertyToModify;
      },
    },
  },
  Railroad: {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M60,120 l80,0 M60,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M74,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M116,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M130,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
            transform: 'translate(0,14)',
            strokeWidth: 3,
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(20,33) scale(0.8)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(20,43) scale(0.8)';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        return this.unknown;
      },
      get mobility() {
        return this.friendly;
      },
    },
  },
  Towed: {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M85 134h30m-40 0a5 5 0 1010 0 5 5 0 10-10 0m40 0a5 5 0 1010 0 5 5 0 10-10 0',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            //! Change - added the transform object to get better matches in equipment modifiers
            d: 'M 73 181 H 127 M 58 181 A 5 5 0 1 1 73 181 A 5 5 0 1 1 58 181 M 127 181 A 5 5 0 1 1 142 181 A 5 5 0 1 1 127 181',
            transform: {
              friendly: {
                transform: 'translate(0,0)',
              },
              friendlyTemplated: {
                transform: 'translate(0,0)',
              },
              hostile: {
                transform: 'translate(0,0)',
              },
              hostileTemplated: {
                transform: 'translate(0,0)',
              },
              unknown: {
                transform: 'translate(0,0)',
              },
              pending: {
                transform: 'translate(0,0)',
              },
              neutral: {
                transform: 'translate(0,-10)',
              },
            },
          },
        };
      },
    },
  },
  'Tracked or Self-Propelled': {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'm 85,127 30,0 c 10,0 10,15 0,15 l -30,0 c -10,0 -10,-15 0,-15',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            //! Change - added the transform object to get better matches in equipment modifiers
            d: 'M 65 168 L 135 168 c 9 0 9 15 0 15 L 65 183 C 56 183 56 168 65 168 Z',
            transform: {
              friendly: {
                transform: 'translate(0,0)',
              },
              friendlyTemplated: {
                transform: 'translate(0,0)',
              },
              hostile: {
                transform: 'translate(0,20)',
              },
              hostileTemplated: {
                transform: 'translate(0,20)',
              },
              unknown: {
                transform: 'translate(0,20)',
              },
              pending: {
                transform: 'translate(0,20)',
              },
              neutral: {
                transform: 'translate(0,0)',
              },
            },
          },
        };
      },
    },
  },
  Wheeled: {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M76,135a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M96,135a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M116,135a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get mobility() {
        return this.friendly;
      },
    },
  },
  'VTOL (Vertical Take-off and Landing)': {
    type: 'Aerial',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'VTOL',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '143';
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Close Range': {
    type: 'Aerial',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'CR',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Very Heavy': {
    type: 'Unit Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'VH',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Heavy: {
    type: 'Unit Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'H',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '147';
        return propertyToModify;
      },
    },
  },
  Medium: {
    type: 'Unit Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'M',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Light: {
    type: 'Unit Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'L',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Long Range': {
    type: 'Distance Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'LR',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Short Range': {
    type: 'Distance Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'SR',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Low to Medium Altitude': {
    type: 'Aerial',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'LMA',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Composite: {
    type: 'Capability',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'COMP',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: '30',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        propertyToModify.text_1.fontSize = '18';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Security Force Assistance': {
    type: 'Capability',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'SFA',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'High Altitude': {
    type: 'Aerial',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'HA',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Medium to High Altitude': {
    type: 'Aerial',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'MHA',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Medium Altitude': {
    type: 'Aerial',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'MA',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Medium Range': {
    type: 'Distance Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'MR',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Launcher (Unmanned Aerial System)': {
    type: 'Aerial',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M80,140 L115,120 120,140',
          transform: 'translate(0,6)',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
    },
  },
  'Recovery (Unmanned Aerial System)': {
    type: 'Aerial',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 70,125 c0,20 60,20 60,0',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
    },
  },
  Laboratory: {
    type: 'CBRN',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'LAB',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Casualty Staging': {
    type: 'Medical',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'CS',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Dental: {
    type: 'Medical',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'D',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Psychological Medical Unit': {
    type: 'Medical',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'P',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Analysis: {
    type: 'Military Intelligence',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 100,120 0,-35 m 0,60 -30,-25 60,0 z',
          transform: 'translate(55,77) scale(0.45)',

        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(55,86) scale(0.45)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
    },
  },
  'Direction Finding': {
    type: 'Military Intelligence',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 120,120 0,-60 m 0,58 -30,-25 z m0,0 30, -25z',
          transform: 'translate(154,171) scale(0.45) rotate(180)',
          strokeWidth: 6,
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(154,180) scale(0.45) rotate(180)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
    },
  },
  'Electric Ranging': {
    type: 'Military Intelligence',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M120,130 c-40,20 -80,-45 -40,-70 z M100,95 L140,75',
          transform: 'translate(70,103) scale(0.3)',
          strokeWidth: 6,
          fill: 'black',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(70,110) scale(0.3)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
    },
  },
  Intercept: {
    type: 'Military Intelligence',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 100,120 0,-35 m 0,60 -30,-25 60,0 z',
          transform: 'translate(55,77) scale(0.45)',
          strokeWidth: 6,
          fill: 'black',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(55,86) scale(0.45)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
    },
  },
  Jamming: {
    type: 'Military Intelligence',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M25 120c10 0 0 10 10 10s0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10m-150 5c10 0 0 10 10 10s0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return {
          mobility: true,
          path_1: {
            d: 'M126 146c-8 0 0-8-8-8s0 8-8 8 0-8-8-8 0 8-8 8 0-8-8-8 0 8-8 8 0-8-10-8m70-4c-8 0 0-8-8-8s0 8-8 8 0-8-8-8 0 8-8 8 0-8-8-8 0 8-8 8 0-8-8-8 0 8-8 8 0-8-8-8 0 8-5 8',
          },
        };
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return {
          mobility: true,
          path_1: {
            d: 'M133 150c-9 0 0-10-9-10-10 0 0 10-10 10-9 0 0-10-9-10-10 0 0 10-10 10-9 0 0-10-9-10s0 10-9 10c-10 0 0-10-13-10m83-4c-9 0 0-10-9-10-10 0 0 10-10 10-9 0 0-10-9-10s0 10-9 10c-10 0 0-10-10-10-9 0 0 10-9 10-10 0 0-10-10-10-9 0 0 10-9 10s0-10-9-10c-10 0 0 10-7 10',
          },
        };
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        return {
          mobility: true,
          path_1: {
            d: 'M45 124c10 0 0 10 10 10s0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10m-110 5c10 0 0 10 10 10s0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10 0-10 10-10 0 10 10 10',
          },
        };
      },
      get mobility() {
        return this.friendly;
      },
    },
  },
  Search: {
    type: 'Military Intelligence',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 120,120 0,-60 m 0,58 -30,-25 z m0,0 30, -25z',
          transform: 'translate(46,92) scale(0.45)',
          strokeWidth: 6,
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(46,101) scale(0.45)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(46,97) scale(0.45)';
        return propertyToModify;
      },
    },
  },
  Tactical: {
    type: 'Military Intelligence',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'TAC',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Support: {
    type: 'Military Intelligence',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'SPT',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Strategic: {
    type: 'Military Intelligence',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'STR',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Supply: {
    type: 'Quartermaster',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M25,120 l150,0',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      hostile: {
        path_1: {
          d: 'M57,130 l85,0',
        },
      },
      get hostileTemplated() {
        return this.hostile;
      },
      unknown: {
        path_1: {
          d: 'M45,130 l111,0',
        },
      },
      get pending() {
        return this.unknown;
      },
      neutral: {
        path_1: {
          d: 'M45,120 l110,0',
        },
      },
    },
  },
  Intermodal: {
    type: 'Transportation',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 80,129 40,0 0,-4 8,9 -8,9 0,-4 -40,0 0,4 -8,-9 8,-9 z',
          strokeWidth: 3,
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.d = 'm 80,133 40,0 0,-4 8,9 -8,9 0,-4 -40,0 0,4 -8,-9 8,-9 z';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        return this.unknown;
      },
    },
  },
  'Recovery (Maintenance)': {
    type: 'Maintenance',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M77,126 c8,0 8,16 0,16 m6,-8 l35,0 m6,-8 c-8,0 -8,16 0,16',
            strokeWidth: 3,
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get mobility() {
        return this.friendly;
      },
    },
  },
  'Cross Country Vehicle': {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M67,130 l65,0 M70,137a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M95,137a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M120,137a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(20,30) scale(0.8)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            d: 'M 28 180 H 172 M 35 197 A 5 5 0 1 1 35 184 A 5 5 0 1 1 35 197 M 165 197 A 5 5 0 1 1 165 184 A 5 5 0 1 1 165 197 M 100 197 A 5 5 0 1 1 100 184 A 5 5 0 1 1 100 197',
            transform: {
              friendly: {
                transform: 'translate(0,-15)',
              },
              friendlyTemplated: {
                transform: 'translate(0,-15)',
              },
              hostile: {
                transform: 'translate(0,0)',
              },
              hostileTemplated: {
                transform: 'translate(0,0)',
              },
              unknown: {
                transform: 'translate(0,-3)',
              },
              pending: {
                transform: 'translate(0,-3)',
              },
              neutral: {
                transform: 'translate(0,-20)',
              },
            },
          },
        };
      },
    },
  },
  'Mine Layer Launcher': {
    type: 'Equipment',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 80,130 0,10 40,0 0,-10 z',
          fill: 'black',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
    },
  },
  'Limited Cross Country Vehicle': {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M67,132 l65,0 M67,139a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M122,139a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(20,30) scale(0.8)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            d: 'M 28 180 H 172 M 30 195 A 5 5 0 1 1 39 186 A 5 5 0 1 1 30 195 M 161 195 A 5 5 0 1 1 170 186 A 5 5 0 1 1 161 195',
            transform: {
              friendly: {
                transform: 'translate(0,-15)',
              },
              friendlyTemplated: {
                transform: 'translate(0,-15)',
              },
              hostile: {
                transform: 'translate(0,0)',
              },
              hostileTemplated: {
                transform: 'translate(0,0)',
              },
              unknown: {
                transform: 'translate(0,-3)',
              },
              pending: {
                transform: 'translate(0,-3)',
              },
              neutral: {
                transform: 'translate(0,-20)',
              },
            },
          },
        };
      },
    },
  },
  'Wheeled and Tracked': {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M68 135a7 7 0 1014 0 7 7 0 10-14 0m25-7h30c10 0 10 15 0 15H93c-10 0-10-15 0-15',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(20,30) scale(0.8)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            //! Change - added the transform object to get better matches in equipment modifiers
            // d: 'M68 135a7 7 0 1014 0 7 7 0 10-14 0m25-7h30c10 0 10 15 0 15H93c-10 0-10-15 0-15',
            d: 'M 79 167 L 135 167 c 9 0 9 15 0 15 L 80 182 C 69 182 69 167 79 167 Z M 57 167 A 1 1 0 0 0 57 182 A 1 1 0 0 0 57 167',
            transform: {
              friendly: {
                transform: 'translate(0,0)',
              },
              friendlyTemplated: {
                transform: 'translate(0,0)',
              },
              hostile: {
                transform: 'translate(0,20)',
              },
              hostileTemplated: {
                transform: 'translate(0,20)',
              },
              unknown: {
                transform: 'translate(0,20)',
              },
              pending: {
                transform: 'translate(0,20)',
              },
              neutral: {
                transform: 'translate(0,0)',
              },
            },
          },
        };
      },
    },
  },
  Production: {
    type: 'Installation',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'PROD',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        propertyToModify.text_1.y = '140';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        return this.unknown;
      },
    },
  },
  Repair: {
    type: 'Installation',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'RPR',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Research: {
    type: 'Installation',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'RSH',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Service: {
    type: 'Installation',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'SVC',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Storage: {
    type: 'Installation',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'STOR',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Test Facility': {
    type: 'Installation',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'TEST',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
          fontWeight: 'bold',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '155';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Premature IED': {
    type: 'Activity',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'P',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.fontSize = '19';
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Rail: {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M60,120 l80,0 M60,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M74,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M116,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M130,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
            transform: 'translate(0,14)',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(31,49) scale(0.7)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(25,50) scale(0.75)';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        return this.unknown;
      },
      get mobility() {
        return this.friendly;
      },
    },
  },
  Airborne: {
    type: 'Capabilities',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M75,140 C75,125 100,125 100,140 C100,125 125,125 125,140',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
    },
  },
  'Air Assault': {
    type: 'Capabilities',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M85,55 L100,75 115,55',
          transform: 'translate(0,66)',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,76)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,73)';
        return propertyToModify;
      },
    },
  },
  //! symbols I have added
  'Combat and Operational Stress Control (COSC)': {
    type: 'Medical',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M997 341c91 0 160-16 207-46 47-31 78-68 94-112 15-44 26-118 30-221 5-114 30-199 77-254 46-56 122-84 229-84v38c-38 3-64 18-78 45s-21 84-21 171c0 128-13 227-40 297s-81 126-163 170c-81 43-193 67-335 70v317c0 78 4 129 13 152s28 41 57 55c30 14 74 21 135 21v38H599v-38c60 0 104-7 133-19s48-30 58-54 15-75 15-155V415c-144-3-255-27-335-69-79-43-133-99-161-168-29-69-43-169-43-301 0-84-6-140-19-167-13-28-39-44-79-48v-38c67 1 122 12 163 32 42 20 75 55 100 106s39 118 42 200c5 102 15 176 30 220s46 81 94 112c49 31 118 47 208 47V-96c0-78-5-128-14-151s-28-42-56-55c-29-13-74-20-136-21v-37h603v37c-61 1-106 8-135 21s-48 31-57 54-13 74-13 152v437z',
          transform: 'translate(105,120) scale(0.025)',
          fill: 'black',
          strokeWidth: 3,
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(100,120) scale(0.02)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(105,120) scale(0.025)';
        return propertyToModify;
      },
    },
  },
  'Barge - not self-propelled': {
    type: 'Maritime',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'YB',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Blood Support': {
    type: 'Medical',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M393 368c-28 108-80 127-80 194 0 44 41 68 80 68 32 0 66-31 66-71 0-62-39-76-66-191z',
          transform: 'translate(80,50) scale(0.15)',
          fill: 'black',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(60,50) scale(0.15)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(70,50) scale(0.15)';
        return propertyToModify;
      },
    },
  },
  Control: {
    type: 'Transportation',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 98,130 2,-4 2,4 m -8,8 -4,-2 4,-2 m 8,8 -2,4 -2,-4 m 8,-8 4,2 -4,2 m -14,-2 16,0 m -8,-8 0,16',
          transform: 'translate(5,5) scale(0.95)',
          strokeWidth: 2,
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,5)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,10)';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,2)';
        return propertyToModify;
      },
    },
  },
  'Dental Services': {
    type: 'Medical',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M475 12c-48 1-107 15-169 24C150 22 12-44 12 164c0 93 15 162 54 291-14 217 27 507 52 504 14 47 68-145 86-340 23-84 145-85 166 4 13 186 92 363 106 340 18-15 68-287 60-509 57-117 57-200 57-290 0-123-47-153-118-152h0z',
          transform: 'translate(125,105) scale(0.04)',
          fill: 'black',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(104,105) scale(0.04)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(115,108) scale(0.04)';
        return propertyToModify;
      },
    },
  },
  Decontamination: {
    type: 'CBRN',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'D',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Guerrilla: {
    type: 'Irregular Forces',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'G',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Landing Craft': {
    type: 'Maritime',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'LC',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Light and Medium': {
    type: 'Unit Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'L/M',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Low Altitude': {
    type: 'Unit Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'LA',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Medical Bed': {
    type: 'Medical',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M114 128v-20m0 3l11 11zm0 11h45m0-8v19m0 0a4 4 0 000 9 4 4 0 000-9zm-45 0a4 4 0 000 9 4 4 0 000-9v-5',
          strokeWidth: 3,
          fill: 'black',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(38,47) scale(0.6)';
        propertyToModify.path_1.strokeWidth = 4;
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.path_1.transform = 'translate(40,50) scale(0.64)';
        return propertyToModify;
      },
    },
  },
  Multifunctional: {
    type: 'Unit Modifier',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'MF',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Ocean-going Tug Boat': {
    type: 'Maritime',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'AT',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  Mountain: {
    type: 'Infantry',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M 90 140 L 90 140 L 90 140 Z L 90 140 M 90 140 L 100 120 L 110 140 z M 90 140 L 80 120 L 70 140 Z',
          transform: 'translate(10,6)',
          fill: 'black',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.path_1.transform = 'translate(10,12)';
        return propertyToModify;
      },
    },
  },
  Optometry: {
    type: 'Medical',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M50 30c-15 0-28 8-37 20 9 12 22 20 37 20s28-8 37-20c-9-12-22-20-37-20zm0 35a15 15 0 110-30 15 15 0 010 30zm0-23a8 8 0 100 16 8 8 0 000-16z',
          transform: 'translate(105,92) scale(0.65)',
          fill: 'black',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(100,95) scale(0.45)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(102,102) scale(0.5)';
        return propertyToModify;
      },
    },
  },
  'Preventative Medicine': {
    type: 'Medical',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M 111 134 L 121 120 L 130 134 L 126 134 L 123 138 L 118 130 L 115 134 Z M 110 136 L 106 142 L 135.35 142 L 134 140 L 131 136 L 127 136 L 124 140 L 122 140 L 118 134 L 116 136 L 110 136',
          transform: 'translate(-44,-72) scale(1.5)',
          fill: 'black',
          strokeWidth: 1,
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,-12) scale(1)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(-17,-31) scale(1.2)';
        return propertyToModify;
      },
    },
  },
  Railway: {
    type: 'Transportation',
    affiliation: {
      friendly: {
        mobility: true,
        path_1: {
          d: 'M60,120 l80,0 M60,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M74,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M116,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0 M130,125a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
          strokeWidth: 3,
          transform: 'translate(0, 10)',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(30, 50) scale(0.7)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(30, 60) scale(0.7)';
        return propertyToModify;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            //! Change - added the transform object to get better matches in equipment modifiers
            d: 'M 28 180 H 172 M 35 197 A 5 5 0 1 1 35 184 A 5 5 0 1 1 35 197 M 165 197 A 5 5 0 1 1 165 184 A 5 5 0 1 1 165 197 M 53 197 A 5 5 0 1 1 53 184 A 5 5 0 1 1 53 197 M 147 184 A 5 5 0 1 1 147 197 A 5 5 0 1 1 147 184',
            transform: {
              friendly: {
                transform: 'translate(0,-15)',
              },
              friendlyTemplated: {
                transform: 'translate(0,-15)',
              },
              hostile: {
                transform: 'translate(0,0)',
              },
              hostileTemplated: {
                transform: 'translate(0,0)',
              },
              unknown: {
                transform: 'translate(0,0)',
              },
              pending: {
                transform: 'translate(0,0)',
              },
              neutral: {
                transform: 'translate(0,-20)',
              },
            },
          },
        };
      },
    },
  },
  'Service Craft Yard': {
    type: 'Maritime',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'YY',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Tug, Harbor': {
    type: 'Maritime',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'YT',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Surface Deployment and Distribution Command': {
    type: 'Maritime',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'SDDC',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        propertyToModify.text_1.fontSize = '16';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Veterinary Service': {
    type: 'Medical',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'V',
          x: '112',
          y: '140',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        return this.friendly;
      },
    },
  },
  'Watercraft (Generic Vessel)': {
    type: 'Capability',
    affiliation: {
      friendly: {
        path_1: {
          d: 'M 112 63 l -9 0 l 0 -9 l -15 0 l 0 9 l -9 0 l 0 15 l 33 0 Z',
          fill: 'black',
          transform: 'translate(23, 82) scale(0.8)',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(23, 85) scale(0.8)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
    },
  },
  'Coerced Recruitment': {
    type: 'Activity',
    affiliation: {
      friendly: {
        text_1: {
          symbolText: 'CR',
          x: '100',
          y: '145',
          fontSize: '22',
          textAnchor: 'middle',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.text_1.y = '145';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        const propertyToModify = JSON.parse(JSON.stringify(this.hostile));
        propertyToModify.text_1.y = '150';
        return propertyToModify;
      },
    },
  },
  'Over Snow (Prime Mover)': {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M122 143H87 M88 123a10 10 0 000 20',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            //! Change - added the transform object to get better matches in equipment modifiers
            d: 'M 65 183 C 55 183 53 174 56 168 M 65 183 L 135 183 Z',
            transform: {
              friendly: {
                transform: 'translate(0,-0)',
              },
              friendlyTemplated: {
                transform: 'translate(0,0)',
              },
              hostile: {
                transform: 'translate(0,10)',
              },
              hostileTemplated: {
                transform: 'translate(0,10)',
              },
              unknown: {
                transform: 'translate(0,10)',
              },
              pending: {
                transform: 'translate(0,10)',
              },
              neutral: {
                transform: 'translate(0,-5)',
              },
            },
          },
        };
      },
    },
  },
  'Pack Animal': {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'm 84,143 9,-15 7,15 7,-15 9,15',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            d: 'M 84 190 L 93 175 L 100 190 L 107 175 L 116 190',
            transform: {
              friendly: {
                transform: 'translate(0,-5)',
              },
              friendlyTemplated: {
                transform: 'translate(0,-5)',
              },
              hostile: {
                transform: 'translate(0,5)',
              },
              hostileTemplated: {
                transform: 'translate(0,5)',
              },
              unknown: {
                transform: 'translate(0,5)',
              },
              pending: {
                transform: 'translate(0,5)',
              },
              neutral: {
                transform: 'translate(0,-10)',
              },
            },
          },
        };
      },
    },
  },
  Sled: {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'M115,125 C125,125 125,135 115,135 L85,135 C75,135 75,125 85,125',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(1,7)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            d: 'M 50 175 C 50 185 50 190 60 190 L 140 190 C 150 190 150 185 150 175',
            transform: {
              friendly: {
                transform: 'translate(0,0)',
              },
              friendlyTemplated: {
                transform: 'translate(0,0)',
              },
              hostile: {
                transform: 'translate(0,0)',
              },
              hostileTemplated: {
                transform: 'translate(0,0)',
              },
              unknown: {
                transform: 'translate(0,0)',
              },
              pending: {
                transform: 'translate(0,0)',
              },
              neutral: {
                transform: 'translate(0,-10)',
              },
            },
          },
        };
      },
    },
  },
  Riverine: {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'm 70,125 c0,20 60,20 60,0z',
            strokeWidth: 3,
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            d: 'M 50 185 C 60 205 140 205 150 185 Z',
            transform: {
              friendly: {
                transform: 'translate(0,-15)',
              },
              friendlyTemplated: {
                transform: 'translate(0,-15)',
              },
              hostile: {
                transform: 'translate(0,0)',
              },
              hostileTemplated: {
                transform: 'translate(0,0)',
              },
              unknown: {
                transform: 'translate(0,0)',
              },
              pending: {
                transform: 'translate(0,0)',
              },
              neutral: {
                transform: 'translate(0,-20)',
              },
            },
          },
        };
      },
    },
  },
  Ski: {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          mobility: true,
          path_1: {
            d: 'm 95,147 -9,-8 m 28,0 -9,8 m -15,-24 20,20 m 0,-20 -20,20',
            strokeWidth: 3,
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            d: 'M 95 204 L 86 196 M 114 196 L 105 204 M 90 180 L 110 200 M 110 180 L 90 200',
            transform: {
              friendly: {
                transform: 'translate(0,-10)',
              },
              friendlyTemplated: {
                transform: 'translate(0,-10)',
              },
              hostile: {
                transform: 'translate(0,0)',
              },
              hostileTemplated: {
                transform: 'translate(0,0)',
              },
              unknown: {
                transform: 'translate(0,0)',
              },
              pending: {
                transform: 'translate(0,0)',
              },
              neutral: {
                transform: 'translate(0,-15)',
              },
            },
          },
        };
      },
    },
  },
  'Wheeled Test': {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          path_1: {
            d: 'M 100 137 A 1 1 0 0 0 100 147 A 1 1 0 0 0 100 137 M 85 137 A 1 1 0 0 0 85 147 A 1 1 0 0 0 85 137 M 115 137 A 1 1 0 0 0 115 147 A 1 1 0 0 0 115 137',
            strokeWidth: 3,
            transform: 'translate(0,-3)',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,0)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
      get equipmentCase() {
        return {
          path_1: {
            d: 'M 100 137 A 1 1 0 0 0 100 147 A 1 1 0 0 0 100 137 M 85 137 A 1 1 0 0 0 85 147 A 1 1 0 0 0 85 137 M 115 137 A 1 1 0 0 0 115 147 A 1 1 0 0 0 115 137',
            strokeWidth: 3,
            transformCase: {
              neutral: {
                transform: 'translate(0,0)',
              },
            },
          },
        };
      },
    },
  },
  'Wheeled Test Limited': {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          path_1: {
            d: 'M 85 137 A 1 1 0 0 0 85 147 A 1 1 0 0 0 85 137 M 115 137 A 1 1 0 0 0 115 147 A 1 1 0 0 0 115 137',
            strokeWidth: 3,
            transform: 'translate(0,-3)',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        const propertyToModify = JSON.parse(JSON.stringify(this.friendly));
        propertyToModify.path_1.transform = 'translate(0,0)';
        return propertyToModify;
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return this.hostile;
      },
      get pending() {
        return this.hostile;
      },
      get neutral() {
        return this.hostile;
      },
      get equipmentCase() {
        return {
          path_1: {
            d: 'M 85 137 A 1 1 0 0 0 85 147 A 1 1 0 0 0 85 137 M 115 137 A 1 1 0 0 0 115 147 A 1 1 0 0 0 115 137',
            strokeWidth: 3,
            transformCase: {
              neutral: {
                transform: 'translate(0,0)',
              },
            },
          },
        };
      },
    },
  },
  Armored: {
    type: 'Armor',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 90,60 20,0 c 10,0 10,15 0,15 L 90,75 C 80,75 80,60 90,60',
          transform: 'translate(0,68)',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
    },
  },
  'Armored Tracked Equipment': {
    type: 'Armor',
    affiliation: {
      friendly: {
        path_1: {
          d: 'm 90,60 20,0 c 10,0 10,15 0,15 L 90,75 C 80,75 80,60 90,60',
          transform: 'translate(0,68)',
        },
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return this.friendly;
      },
      get hostileTemplated() {
        return this.friendly;
      },
      get unknown() {
        return this.friendly;
      },
      get pending() {
        return this.friendly;
      },
      get neutral() {
        return this.friendly;
      },
      get equipmentCase() {
        return {
          friendly: {
            path_1: {
              d: 'M 92 135 L 108 135 C 118 135 118 150 108 150 L 92 150 C 82 150 82 135 92 135 Z',
              strokeWidth: 3,
              transform: 'translate(0,0)',
            },
          },
          get friendlyTemplated() {
            return this.friendly;
          },
          get hostile() {
            return this.friendly;
          },
          get hostileTemplated() {
            return this.friendly;
          },
          get unknown() {
            return this.friendly;
          },
          get pending() {
            return this.friendly;
          },
          get neutral() {
            return this.friendly;
          },
        };
      },
    },
  },
  //! Amphibious is a mess. I really think that the equipment functionality needs a refactor
  Amphibious: {
    type: 'Mobility',
    affiliation: {
      get friendly() {
        return {
          // * Mobility is a special key that when matched up with equipment will translate the path below the symbol in getMod2Data() * //
          mobility: true,
          path_1: {
            d: 'm 25,145 c 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 20,20',
          },
        };
      },
      get friendlyTemplated() {
        return this.friendly;
      },
      get hostile() {
        return {
          mobility: true,
          path_1: {
            d: 'M 70.4 142.4 C 74.8 137 66.8 125 81.4 125 C 100.2 125 81.4 145 100.2 145 C 119 145 100.2 125 119 125 C 133.3 125 125.7 136.6 129.7 142.1',
            transform: 'translate(15, 23) scale(0.85)',
          },
        };
      },
      get hostileTemplated() {
        return this.hostile;
      },
      get unknown() {
        return {
          mobility: true,
          path_1: {
            d: 'M 64 144.9 C 80.4 143.9 63.1 125 81.4 125 C 100.2 125 81.4 145 100.2 145 C 119 145 100.2 125 119 125 C 137.1 125 120.2 143.6 135.9 144.9',
          },
        };
      },
      get pending() {
        return this.unknown;
      },
      get neutral() {
        return {
          mobility: true,
          path_1: {
            d: 'M 45 125 C 61.7 125.9 44.2 145 62.6 145 C 81.4 145 62.6 125 81.4 125 C 100.2 125 81.4 145 100.2 145 C 119 145 100.2 125 119 125 C 137.8 125 119 145 137.8 145 C 155.9 145 138.9 126.2 154.8 125',
          },
        };
      },
      get mobility() {
        return {
          mobility: true,
          path_1: {
            d: 'M 25 195 C 43.8 195 25 175 43.8 175 C 62.6 175 43.8 195 62 195 C 80.8 195 62 175 80.8 175 C 99.6 175 80.8 195 99.4 195 C 118.2 195 99.4 175 118.2 175 C 137 175 118.2 195 137 195 C 155.8 195 137 175 155.8 175 C 174.6 175 155.8 195 175.8 195',
            transform: {
              friendly: {
                transform: 'translate(0,0)',
              },
              friendlyTemplated: {
                transform: 'translate(0,0)',
              },
              hostile: {
                transform: 'translate(0,0)',
              },
              hostileTemplated: {
                transform: 'translate(0,0)',
              },
              unknown: {
                transform: 'translate(0,0)',
              },
              pending: {
                transform: 'translate(0,0)',
              },
              neutral: {
                transform: 'translate(0,-10)',
              },
            },
          },
        };
      },
    },
  },
};

export default mod2Object;
